//stepper Data
export const financeSteps = ["Settings","Home", "About", "Vision", "Services", "Team", "Contact"];
export const servicesSteps = ["Settings","Home", "About", "Services", "Team", "Contact"];
export const medicalSteps = ["Settings","Home","About","Vision", "Services", "Team", "Statistics", "Contact"];
export const bankSteps = ["Settings","Home", "About", "Services", "Team", "Contact"];
export const logisticSteps = ["Settings","Home",  "About","Vision", "Services", "Team", "Contact"];

//Font Family
export const Fonts = [
  "Nunito Sans",
  "Abadi MT Condensed Light",
  "Albertus Extra Bold",
  "Antique Olive",
  "Arial",
  "Arial Black",
  "Arial MT",
  "Arial Narrow",
  "Bazooka",
  "Book Antiqua",
  "Bookman Old Style",
  "Boulder",
  "Calisto MT",
  "Calligrapher",
  "Century Gothic",
  "Century Schoolbook",
  "Cezanne",
  "CG Omega",
  "CG Times",
  "Charlesworth",
  "Chaucer",
  "Clarendon Condensed",
  "Comic Sans MS",
  "Copperplate Gothic Bold",
  "Copperplate Gothic Light",
  "Cornerstone",
  "Coronet",
  "Courier",
  "Courier New",
  "Cuckoo",
  "Dauphin",
  "Denmark",
  "Fransiscan",
  "Garamond",
  "Geneva",
  "Haettenschweiler",
  "Heather",
  "Helvetica",
  "Herald",
  "Impact",
  "Jester",
  "Letter Gothic",
  "Lithograph",
  "Lithograph Light",
  "Long Island",
  "Lucida Console",
  "Lucida Handwriting",
  "Lucida Sans",
  "Lucida Sans Unicode",
  "Marigold",
  "Market",
  "Matisse ITC",
  "MS LineDraw",
  "News GothicMT",
  "OCR A Extended",
  "Old Century",
  "Pegasus",
  "Pickwick",
  "Poster",
  "Pythagoras",
  "Sceptre",
  "Sherwood",
  "Signboard",
  "Socket",
  "Steamer",
  "Storybook",
  "Subway",
  "Tahoma",
  "Technical",
  "Teletype",
  "Tempus Sans ITC",
  "Times",
  "Times New Roman",
  "Times New Roman PS",
  "Trebuchet MS",
  "Tristan",
  "Tubular",
  "Unicorn",
  "Univers",
  "Univers Condensed",
  "Vagabond",
  "Verdana",
  "Westminster",
];


export const financeData = {
  pages: {
    settings:{
      companylogo: { type: 'image', size: "", label: "Company logo in both dark and light modes", value: "", format: ".zip", required: true },
      primaryColor:{type:"color",label:"Primary color",defaultColor:"#000",value:"",required:true},
      secondaryColor:{type:"color",label:"Secondary color",defaultColor:"#1F4A45",value:"",required:true},
      fontStyle:{type:"dropdown",label:"Fonts",defaultValue:"Nunito Sans",value:"",required:true},
    },
    homePage: {
      CompanySlogan: { label: "Company Tagline", type: "textarea", value: "", required: true },
      BannerTitle: { label: "Banner Title", type: "text", value: "", required: true },
      BannerBackgroundImage: { label: "Banner Background Image (Minimum of 2 and Maximum of 4)", size: "1920 X 1080 px ", type: "image", value: "", format: ".zip", required: true },
      
    },

    aboutPage: {
      aboutTitle: { label: "About Your Company", type: "textarea", value: "", required: false },
      aboutImage: { label: "About Banner Image For About Section", type: "image", value: "", size: "900 X 930 px", format: "image/png, image/jpeg, image/jpg", required: false },
    },
    visionPage: {
      visionmission: {
        type: "array",
        align: "column",
        value: [
          { visionname: { label: "Vision", type: "textarea", value: "", required: false }, missionname: { label: "Mission", type: "textarea", value: "", required: false } },


        ],

      },
      visionImage: { label: "Vision & Mission Image (Maximum of 3)", type: "image", value: "", size: "674 X 800 px", format: ".zip", required: false },


    },
    servicesPage: {
      serviceTitle: { label: "About Your Services", type: "textarea", value: "", required: false },
      services: {
        type: "array",
        align: "column",

        value: [
          { name: { label: "Service 1 Title", type: "text", value: "", required: true }, description: { label: " Service 1 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 2 Title", type: "text", value: "", required: true }, description: { label: " Service 2 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 3 Title (optional)", type: "text", value: "", required: false }, description: { label: " Service 3 Content (optional)", type: "textarea", value: "", required: false } },
          { name: { label: "Service 4 Title (optional)", type: "text", value: "", required: false }, description: { label: " Service 4 Content (optional)", type: "textarea", value: "", required: false } },

        ],

      },
      serviceImage: { label: "Service Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "674 X 800 px", format: ".zip", required: true },

    },
    teamPage: {
      teamMembers: {
        type: "array",
        align: "row",
        value: [
          { name1: { label: "Employee 1 Name", type: "text", value: "", required: false }, role: { label: "Employee 1 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 2 Name", type: "text", value: "", required: false }, role: { label: "Employee 2 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 3 Name", type: "text", value: "", required: false }, role: { label: "Employee 3 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 4 Name", type: "text", value: "", required: false }, role: { label: "Employee 4 role", type: "text", value: "", required: false } },
        ],
      },
      teamImage: { label: "Team Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "674 X 800 px", format: ".zip", required: false },

    },
    contactPage: {

      companyAddress: { label: "Company Location", type: "textarea", value: "", required: true },
      mapintegration: { label: "Map Integration Url", type: "text", value: "", required: false },
      phoneNumber: { type: "text", value: "", label: "Phone Number", required: true },
      emailAddress: { type: "text", value: "", label: "Email Address", required: true },
      socialMediaLinks: {
        type: "array",
        align: 'row',
        value: [
          { name1: { type: "text", value: "Facebook", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Facebook Link" } },
          { name1: { type: "text", value: "LinkedIn", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "LinkedIn Link" } },
          { name1: { type: "text", value: "Instagram", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Instagram Link" } },
          { name1: { type: "text", value: "Twitter", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Twitter Link" } },
        ],
      },
    },
  },
};


export const itServicesData = {
  
  pages: {
    settingPage:{
      companylogo: { type: 'image', size: "", label: "Company logo in both dark and light modes", value: "", format: ".zip", required: true },
      primaryColor:{type:"color",label:"Primary color",defaultColor:"#592F80",value:"",required:true},
      secondaryColor:{type:"color",label:"Secondary color",defaultColor:"#E36899",value:"",required:true},
      fontStyle:{type:"dropdown",label:"Fonts",defaultValue:"Nunito Sans",value:"",required:true},
    },
    homePage: {
      
      BannerTitle: { label: "Banner Title", type: "text", value: "", required: true },
      CompanySlogan: { label: "Company Tagline", type: "textarea", value: "", required: true },
      BannerBackgroundImage: { label: "Banner Background Image (Minimum of 2 and Maximum of 4)", size: "1472 X 736 px ", type: "image", value: "", format: ".zip", required: true },
    },

    aboutPage: {
      aboutTitle: { label: "About Your Company", type: "textarea", value: "", required: false },
      aboutImage: { label: "About Banner Image For About Section", type: "image", value: "", size: "736 X 736 px", format: "image/png, image/jpeg, image/jpg", required: false },
    },
    servicesPage: {
      serviceTitle: { label: "About Your Services", type: "textarea", value: "", required: false },
      services: {
        type: "array",
        align: "column",
        value: [
          { name: { label: "Service 1 Title", type: "text", value: "", required: true }, description: { label: " Service 1 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 2 Title", type: "text", value: "", required: true }, description: { label: " Service 2 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 3 Title (optional)", type: "text", value: "", required: false }, description: { label: " Service 3 Content (optional)", type: "textarea", value: "", required: false } },
          { name: { label: "Service 4 Title (optional)", type: "text", value: "", required: false }, description: { label: " Service 4 Content (optional)", type: "textarea", value: "", required: false } },

        ],

      },
      serviceImage: { label: "Service Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "736 X 552 px", format: ".zip", required: true },

    },
    teamPage: {
      teamMembers: {
        type: "array",
        align: 'row',
        value: [
          { name1: { label: "Employee 1 Name", type: "text", value: "", required: false }, role: { label: "Employee 1 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 2 Name", type: "text", value: "", required: false }, role: { label: "Employee 2 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 3 Name", type: "text", value: "", required: false }, role: { label: "Employee 3 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 4 Name", type: "text", value: "", required: false }, role: { label: "Employee 4 role", type: "text", value: "", required: false } },
        ],
      },
      teamImage: { label: "Team Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "300 X 378 px", format: ".zip", required: false },

    },
    contactPage: {

      companyAddress: { label: "Company Location", type: "textarea", value: "", required: true },
      mapintegration: { label: "Map Integration Url", type: "text", value: "", required: false },
      phoneNumber: { type: "text", value: "", label: "Phone Number", required: true },
      emailAddress: { type: "text", value: "", label: "Email Address", required: true },
      socialMediaLinks: {
        type: "array",
        align: 'row',
        value: [
          { name1: { type: "text", value: "Facebook", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Facebook Link" } },
          { name1: { type: "text", value: "LinkedIn", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "LinkedIn Link" } },
          { name1: { type: "text", value: "Instagram", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Instagram Link" } },
          { name1: { type: "text", value: "Twitter", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Twitter Link" } },
        ],
      },
    },
  },
};
export const healthcareData = {
  pages: {
    settings:{
      companylogo: { type: 'image', size: "", label: "Company logo in both dark and light modes", value: "", format: ".zip", required: true },
      primaryColor:{type:"color",label:"Primary color",defaultColor:"#40A77A",value:"",required:true},
      secondaryColor:{type:"color",label:"Secondary color",defaultColor:"#6EC1E4",value:"",required:true},
      fontStyle:{type:"dropdown",label:"Fonts",defaultValue:"Nunito Sans",value:"",required:true},
    },
    homePage: {
      
      BannerTitle: { label: "Banner Title", type: "text", value: "", required: true },
      CompanySlogan: { label: "Company Tagline", type: "textarea", value: "", required: true },
      BannerBackgroundImage: { label: "Banner Background Image", size: "970 X 600 px", type: "image", value: "", format: ".zip", required: true },
    },

    aboutPage: {
      aboutTitle: { label: "About Your Company", type: "textarea", value: "", required: false },
      aboutkeyPoints: { label: "Key Points of Company", type: "textarea", value: "", required: false },
      aboutImage: { label: "About Banner Image For About Section", type: "image", value: "", size: "736 X 736 px", format: "image/png, image/jpeg, image/jpg", required: false },
    },
    visionPage: {
      visionmission: {
        type: "array",
        align: "column",
        value: [
          { visionname: { label: "Vision", type: "textarea", value: "", required: false }, missionname: { label: "Mission", type: "textarea", value: "", required: false } },


        ],

      },
      visionImage: { label: "Vision & Mission Image (Maximum of 3)", type: "image", value: "", size: "674 X 800 px", format: ".zip", required: false },


    },
    servicesPage: {
      serviceTitle: { label: "About Your Services", type: "textarea", value: "", required: false },
      services: {
        type: "array",
        align: 'column',
        value: [
          { name: { label: "Service 1 Title", type: "text", value: "", required: true }, description: { label: " Service 1 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 2 Title", type: "text", value: "", required: true }, description: { label: " Service 2 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 3 Title (optional)", type: "text", value: "", required: false }, description: { label: " Service 3 Content (optional)", type: "textarea", value: "", required: false } },
          { name: { label: "Service 4 Title (optional)", type: "text", value: "", required: false }, description: { label: " Service 4 Content (optional)", type: "textarea", value: "", required: false } },

        ],

      },
      serviceImage: { label: "Service Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "618 X 410 px", format: ".zip", required: true },
    },
    teamPage: {
      aboutTeamMembers: { label: "About Your Team Members", type: "textarea", value: "", required: false },
      teamMembers: {
        type: "array",
        align: "row",
        value: [
          { name1: { label: "Employee 1 Name", type: "text", value: "", required: false }, role: { label: "Employee 1 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 2 Name", type: "text", value: "", required: false }, role: { label: "Employee 2 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 3 Name", type: "text", value: "", required: false }, role: { label: "Employee 3 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 4 Name", type: "text", value: "", required: false }, role: { label: "Employee 4 role", type: "text", value: "", required: false } },
        ],
      },
      teamImage: { label: "Team Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "330 X 300 px", format: ".zip", required: false },

    },
    statisticsPage: {
      appointments: { label: "Years of Experience", type: "number", value: "", required: false },
      clinics: { label: "No of Clinics", type: "number", value: "", required: false },
      doctors: { label: "No of Doctors", type: "number", value: "", required: false },
      successrate: { label: "No of success rate", type: "number", value: "", required: false },
      statisticsImage: { label: "Statistics Background image ", type: "image", value: "", size: "", format: "image/png, image/jpeg, image/jpg", required: false },

    },
    contactPage: {

      companyAddress: { label: "Company Location", type: "textarea", value: "" ,required:true },
      mapintegration: { label: "Map Integration Url", type: "text", value: "" ,required:false },
      phoneNumber: { type: "text", value: "", label: "Phone Number", required: true },
      emailAddress: { type: "text", value: "", label: "Email Address", required: true },
      socialMediaLinks: {
        type: "array",
        align:'row',
        value: [
          { name1: { type: "text", value: "Facebook", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Facebook Link" } },
          { name1: { type: "text", value: "LinkedIn", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "LinkedIn Link" } },
          { name1: { type: "text", value: "Instagram", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Instagram Link" } },
          { name1: { type: "text", value: "Twitter", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Twitter Link" } },
        ],
      }
    },
  },
};
export const bankData = {
  pages: {
    settings:{
      companylogo: { type: 'image', size: "", label: "Company logo in both dark and light modes", value: "", format: ".zip", required: true },
      primaryColor:{type:"color",label:"Primary color",defaultColor:"#254BA1",value:"",required:true},
      secondaryColor:{type:"color",label:"Secondary color",defaultColor:"#fff",value:"",required:true},
      fontStyle:{type:"dropdown",label:"Fonts",defaultValue:"Nunito Sans",value:"",required:true},
    },
    homePage: {

      BannerTitle: { label: "Banner Title", type: "text", value: "", required: true },
      CompanySlogan: { label: "Company Tagline", type: "textarea", value: "", required: true },
      BannerBackgroundImage: { label: "Banner Background Image (Maximum of 2)", size: "3000 X 2000 px", type: "image", value: "", format: ".zip", required: true },
    },

    aboutPage: {
      aboutTitle: { label: "About Your Company", type: "textarea", value: "", required: false },
      aboutkeyPoints: { label: "Key Points of Company(Minimum of 2)", type: "textarea", value: "", required: false },
      aboutImage: { label: "About Banner Image For About Section", type: "image", value: "", size: "504 X 424 px", format: "image/png, image/jpeg, image/jpg", required: false },
    },
    servicesPage: {
      serviceTitle: { label: "About Your Services", type: "textarea", value: "", required: false },
      services: {
        type: "array",
        align: "column",
        value: [
          { name: { label: "Service 1 Title", type: "text", value: "", required: true }, description: { label: "Service 1 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 2 Title", type: "text", value: "", required: true }, description: { label: "Service 2 Content", type: "textarea", value: "", required: true } },
          { name: { label: "Service 3 Title (optional)", type: "text", value: "", required: false }, description: { label: "Service 3 Content (optional)", type: "textarea", value: "", required: false } },
          { name: { label: "Service 4 Title (optional)", type: "text", value: "", required: false }, description: { label: "Service 4 Content (optional)", type: "textarea", value: "", required: false } },

        ],

      },
      serviceImage: { label: "Service Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "330 X 171 px", format: ".zip", required: true },

    },
    teamPage: {
      teamMembers: {
        type: "array",
        align: "row",
        value: [
          { name1: { label: "Employee 1 Name", type: "text", value: "", required: false }, role: { label: "Employee 1 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 2 Name", type: "text", value: "", required: false }, role: { label: "Employee 2 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 3 Name", type: "text", value: "", required: false }, role: { label: "Employee 3 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 4 Name", type: "text", value: "", required: false }, role: { label: "Employee 4 role", type: "text", value: "", required: false } },
        ],
      },
      teamImage: { label: "Team Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "300 X 378 px", format: ".zip", required: false },

    },
    contactPage: {

      companyAddress: { label: "Company Location", type: "textarea", value: "", required: true },
      mapintegration: { label: "Map Integration Url", type: "text", value: "", required: false },
      phoneNumber: { type: "text", value: "", label: "Phone Number", required: true },
      emailAddress: { type: "text", value: "", label: "Email Address", required: true },
      socialMediaLinks: {
        type: "array",
        align: "row",
        value: [
          { name1: { type: "text", value: "Facebook", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Facebook Link" } },
          { name1: { type: "text", value: "LinkedIn", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "LinkedIn Link" } },
          { name1: { type: "text", value: "Instagram", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Instagram Link" } },
          { name1: { type: "text", value: "Twitter", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Twitter Link" } },
        ],
      },
    },
  },
};

export const logisticData = {
  pages: {
    settings:{
      companylogo: { type: 'image', size: "", label: "Company logo in both dark and light modes", value: "", format: ".zip", required: true },
      primaryColor:{type:"color",label:"Primary color",defaultColor:"#232331",value:"",required:true},
      secondaryColor:{type:"color",label:"Secondary color",defaultColor:"#EC1D23",value:"",required:true},
      fontStyle:{type:"dropdown",label:"Fonts",defaultValue:"Nunito Sans",value:"",required:true},
    },
    homePage: {

      BannerTitle: { label: "Banner Title", type: "text", value: "", required: true },
      CompanySlogan: { label: "Company Tagline", type: "textarea", value: "", required: true },
      BannerBackgroundImage: { label: "Banner Background Image (Maximum of 3)", size: "1800 X 818 px", type: "image", value: "", format: ".zip", required: true },
    },

    aboutPage: {
      aboutTitle: { label: "About Your Company", type: "textarea", value: "", required: false },
      aboutImage: { label: "About Banner Image For About Section", type: "image", value: "", size: "1920 X 1103 px", format: "*", required: false },
    },
    visionPage:{
      visionmission: {
          type: "array",
          align:"column",
          value: [
            { visionname: { label: "Vision", type: "textarea", value: "",required:false  }, missionname: {label:"Mission", type: "textarea", value: "" ,required:false } },
          
            
          ],
          
        },
        visionImage: { label: "Vision & Mission Image (Maximum of 3)", type: "image", value: "" ,size:"674 X 800 px",format:".zip",required:false  },


    },
    servicesPage: {
      serviceTitle: { label: "About Your Services", type: "textarea", value: "", required: false },
      services: {
        type: "array",
        align:'column',
        value: [
          { name: { label: "Service 1 Title", type: "text", value: "",required:true  }, description: {label:" Service 1 Content", type: "textarea", value: "" ,required:true } },
          { name: { label: "Service 2 Title", type: "text", value: "",required:true  }, description: {label:" Service 2 Content", type: "textarea", value: "",required:true  } },
          { name: { label: "Service 3 Title (optional)", type: "text", value: "" ,required:false }, description: {label:" Service 3 Content (optional)", type: "textarea", value: "" ,required:false} },
          { name: { label: "Service 4 Title (optional)", type: "text", value: "" ,required:false}, description: {label:" Service 4 Content (optional)", type: "textarea", value: "" ,required:false} },
        ],

      },
      serviceImage: { label: "Service Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "618 X 410 px", format: ".zip", required: true },
     
    },
    teamPage: {
      teamMembers: {
        type: "array",
        align:'row',
        value: [
          { name1: { label: "Employee 1 Name", type: "text", value: "", required: false }, role: { label: "Employee 1 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 2 Name", type: "text", value: "", required: false }, role: { label: "Employee 2 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 3 Name", type: "text", value: "", required: false }, role: { label: "Employee 3 role", type: "text", value: "", required: false } },
          { name1: { label: "Employee 4 Name", type: "text", value: "", required: false }, role: { label: "Employee 4 role", type: "text", value: "", required: false } },
        ],
      },
      teamImage: { label: "Team Image (Minimum of 2 and Maximum of 4)", type: "image", value: "", size: "330 X 300", format: ".zip", required: false },

    },
    contactPage: {

      companyAddress: { label: "Company Location", type: "textarea", value: "" ,required:false },
      mapintegration: { label: "Map Integration Url", type: "text", value: "" ,required:false },
      phoneNumber: { type: "text", value: "", label: "Phone Number", required: false },
      emailAddress: { type: "text", value: "", label: "Email Address", required: false },
      socialMediaLinks: {
        type: "array",
        align:"row",
        value: [
          { name1: { type: "text", value: "Facebook", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Facebook Link" } },
          { name1: { type: "text", value: "LinkedIn", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "LinkedIn Link" } },
          { name1: { type: "text", value: "Instagram", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Instagram Link" } },
          { name1: { type: "text", value: "Twitter", label: "Social Media Name",disabled:true }, link: { type: "text", value: "", label: "Twitter Link" } },
        ],
      },
      // contactImage: { label: "Contact Image", type: "image", value: "" ,size:"1500 X 766",format:"*",required:false  },

    },

  },
};
